import get from 'lodash/get';
import { PROFESSIONALS_TYPES, ROUTES } from '../constants';

const buildProfessionalsQuery = (location) => {
  const { professionals_city, property_city, type } = get(location, 'query', {});
  const pathname = get(location, 'pathname', '');
  const isBrokerCommunity = pathname.includes('broker');
  const isRealtorsAssociation = pathname.includes(ROUTES.REALTORS_ASSOCIATION);

  return {
    $skip: 0,
    $limit: 25,
    city: professionals_city || undefined,
    property_city: property_city || undefined,
    ...(professionals_city || property_city ? { $skip: undefined, $limit: undefined } : {}),
    type: type || PROFESSIONALS_TYPES.AGENCY,
    is_community_member: isBrokerCommunity || undefined,
    is_association_member: isRealtorsAssociation || undefined
  };
};

export default buildProfessionalsQuery;
